import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function FinalCTA() {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-navy-600">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-display font-bold text-white mb-6"
          >
            Prêt à{' '}
            <span className="text-gold-400">simplifier</span>{' '}
            la gestion de vos biens ?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-xl text-navy-200 mb-10"
          >
            Contactez-nous pour discuter de vos besoins. Notre équipe vous répondra sous 24h.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-6"
          >
            <Button
              variant="gold"
              size="xl"
              onClick={() => navigate('/commander')}
              className="group"
            >
              Commander
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <a
              href="tel:+32486494670"
              className="flex items-center gap-2 text-navy-200 hover:text-gold-400 transition-colors font-medium"
            >
              <Phone className="w-5 h-5" />
              +32 486 49 46 70
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
